import axios from 'axios';
import { useState } from 'react';
import { useTranslation } from 'react-i18next'
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const ForgotPassword = () => {
    const { t } = useTranslation()
    const navigate = useNavigate()
    const verifyId = localStorage.getItem('verifyId')
    
    const [showPassword, setShowPassword] = useState(false);
    const [showPassword2, setShowPassword2] = useState(false);
    const [errors, setErrors] = useState({});
    const [inputValue, setInputValue] = useState({
        password: "",
        confirmPassword: "",
    });
    const inputHandler = (e) => {
        const {name, value} = e.target;
        setInputValue({
            ...inputValue,
            [name]: value.trim()
        })
    }

    const validate = () => {
        let errors = {};

        if (!inputValue.password) {
            errors.password = "New Password is required"
        }

        if (!inputValue.confirmPassword) {
            errors.confirmPassword = "Confirm Password is required"
        } else if (inputValue.password !== inputValue.confirmPassword) {
            errors.confirmPassword = "New Password & Confirm Password is not matched"
        }
    
        return errors;
    };

    const submitForm = async (e) => {
        e.preventDefault()

        const formErrors = validate();
        setErrors(formErrors);

        const apiData = {
            id: verifyId,
            newPassword: inputValue.password
        }
        
        if (Object.keys(formErrors).length === 0) {
            try {
                const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/new-password-create`, apiData)
                const data = await response.data

                if(data.status === 1){
                    toast.success(data.message)
                    localStorage.removeItem('verifyId')
                    navigate('/home')
                } else {
                    toast.error(data.message)
                }

            } catch (error) {
                console.log('Error:', error)
            }
        }
    }

    return (
        <>
            <div className='main-content'>
                <div className='padding login-section'>
                    <div className='container'>
                        <div className='login-box mx-auto'>
                            <h4 className='text-center mb-5'>{t('Password Recovery')}</h4>
                            
                            <form action="" className='form form1' onSubmit={submitForm}>
                                <div className='mb-3'>
                                    <div className="icon-box">
                                        <input type={showPassword2 ? "text" : "password"}
                                            className="form-control form-control-user"
                                            placeholder={t("New Password")}
                                            name="password" onChange={inputHandler}/>
                                        <Link className="icon1"
                                            onClick={() => setShowPassword2(!showPassword2)}>
                                            {showPassword2 ? <FaEyeSlash /> : <FaEye />}
                                        </Link>
                                    </div>
                                    {errors.password && <p className="error-text">{errors.password}</p> }
                                </div>

                                <div className='mb-3'>
                                    <div className="icon-box">
                                        <input type={showPassword ? "text" : "password"}
                                            className="form-control form-control-user"
                                            placeholder={t("Confirm Password")}
                                            name="confirmPassword" onChange={inputHandler}/>
                                        <Link className="icon1"
                                            onClick={() => setShowPassword(!showPassword)}>
                                            {showPassword ? <FaEyeSlash /> : <FaEye />}
                                        </Link>
                                    </div>
                                    {errors.confirmPassword && <p className="error-text">{errors.confirmPassword}</p> }
                                </div>

                                <div className='mt-3'>
                                    <button type='submit' className='btn btn1 w-100 mt-4'>{t("Send Code")}</button>
                                </div>
                            </form>

                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ForgotPassword
